<template>
  <el-card class="list">
    <div slot="header">
      <el-breadcrumb>
        <el-breadcrumb-item :to="{name: 'moderation'}">
          Abuse Reports
        </el-breadcrumb-item>
      </el-breadcrumb>
      <div class="search">
        <fuzzy-search collection-name="abuseReports" :properties="['type', 'comment']"></fuzzy-search>
        <el-button size="mini" @click="fetchAll">
          <i class="fa fa-refresh" aria-hidden="true"></i>
        </el-button>
      </div>
    </div>
    <paginator collection-name="abuseReports"></paginator>
    <el-table :data="reports" border>
      <sortable-column prop="type" label="TYPE" width="110" collection-name="abuseReports"></sortable-column>
      <sortable-column prop="ctime" label="CREATED" width="180" collection-name="abuseReports" :formatter="dateFormatter"></sortable-column>
      <sortable-column prop="data_name" label="OBJECT ID" width="180" collection-name="abuseReports"></sortable-column>
      <sortable-column prop="owner_name" label="OWNER" collection-name="abuseReports"></sortable-column>
      <el-table-column width="42" fixed="right">
        <template slot-scope="scope">
          <el-button type="text" @click.prevent="details(scope.row.id)">
            <i class="fa fa-file-text-o" aria-hidden="true"></i>
          </el-button>
        </template>
      </el-table-column>
    </el-table>
  </el-card>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import moment from 'moment'

export default {
  computed: {
    reports () {
      return this.ids.map(id => this.entities[id])
    },
    ...mapState('abuseReports', {
      ids: state => state.paginator.ids,
      entities: state => state.entities
    })
  },

  methods: {
    dateFormatter (row, col) {
      return moment(row.ctime).format('lll')
    },
    details (id) {
      this.select(id)
      this.$router.push({ name: 'abuse-report', params: { id: id } })
    },
    ...mapActions('abuseReports', ['fetchAll', 'select'])
  },

  created () {
    this.fetchAll()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/moderation/AbuseReports.vue